<template>
  <!-- 新素材统计 -->
  <TabsLayout>
    <ElTabPane name="materialist" label="素材统计列表"></ElTabPane>
    <ElTabPane name="labellifecycle" label="内容标签曲线"></ElTabPane>
    <ElTabPane name="matersetting" label="素材管控设置" v-if="authMaterSetting"></ElTabPane>
    <ElTabPane name="matercompare" label="批量素材对比" v-if="routeName === 'matercompare'"></ElTabPane>
    <ElTabPane name="materlifecycle" label="分日数据曲线" v-if="routeName === 'materlifecycle'"></ElTabPane>
    <ElTabPane name="materialdetail" label="计划数据详情" v-if="routeName === 'materialdetail'"></ElTabPane>
  </TabsLayout>
</template>
<script>
import TabsLayout from '@/views/report/tabs-layout.vue'
import { isArray } from '@/common/js/utils'
export default {
  name: 'MediasDefault',
  components: {
    TabsLayout
  },

  computed: {
    routeName() {
      return this.$route.name
    },
    authMaterSetting() {
      const access = this.$store.state.accessAuth
      return isArray(access) && access.includes('M20846')
    }
  }
}
</script>
<style lang="scss" scoped></style>
